'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _cartPopup = require('./cartPopup');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var getState = function getState() {
  cart.getState().then(function (cart) {
    var $cartTotal = (0, _jquery2.default)(_dom2.default.cartTotal);
    var $cartPopupTotal = (0, _jquery2.default)(_dom2.default.cartPopupCount);
    var itemCount = cart.item_count;

    if (itemCount == 0) {
      $cartTotal.removeClass('has-items');
    }

    $cartTotal.text(itemCount);
    $cartPopupTotal.text(itemCount);
  });
};

//Update page
var update = function update(item, meta, dimensions, properties) {
  getState();

  //Refresh cart if on cart page, display popup otherwise
  var $cartContainer = (0, _jquery2.default)(_dom2.default.cartContainer);
  if ($cartContainer.length > 0) {
    _jquery2.default.get('/cart?view=contents').then(function (response) {
      $cartContainer.html(response);
      (0, _jquery2.default)('html, body').animate({
        scrollTop: 0
      }, 750);
    }).done(function () {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  } else {
    (0, _cartPopup.cartPopup)(item, meta, dimensions, properties);
  }
};

//Remove Line Item
var addLineItem = function addLineItem(current) {
  var $product = current.closest(_dom2.default.product);

  var variantId = parseInt($product.find(_dom2.default.productVariant).val());
  var meta = $product.find(_dom2.default.productMeta).text();
  var dimensions = $product.find(_dom2.default.productDimensions).text();

  var properties = {};

  $product.find(_dom2.default.property).each(function (index) {
    var $current = (0, _jquery2.default)(this);

    if ($current.val() != "") {
      var propertyName = $current.attr('name').replace('properties[', '').replace(']', '');
      properties[propertyName] = $current.val();
    }
  });

  cart.addItem(variantId, { quantity: 1, properties: properties }, meta).then(function (item) {
    //Check if frame is added, if so, add to cart
    var finishId = _jsCookie2.default.get('finish_type');
    if (finishId) {
      addCustomFinish(finishId, current);
    }

    //Show updates
    update(item, meta, dimensions, properties);
  }).catch(function (error) {
    alert("error adding to cart: " + error);
  });
};

var addCustomFinish = function addCustomFinish(finishId, current) {
  var $product = current.closest(_dom2.default.product);

  var variantId = parseInt($product.find(_dom2.default.productVariant).val());
  var productHandle = $product.find(_dom2.default.productForm).attr('data-product-handle');
  var productTitle = $product.find(_dom2.default.productForm).attr('data-product-title');
  var supplierCode = _jsCookie2.default.get('finish_code') || false;

  var properties = {
    "_custom_finish_frame": "true",
    "_custom_finish_poster_handle": productHandle,
    "_custom_finish_poster_id": variantId,
    "_supplier_code": supplierCode,
    "Custom finish for ": productTitle
  };

  cart.addItem(parseInt(finishId), { quantity: 1, properties: properties }).then(function (item) {
    // Cookies.remove('finish_type');
    // Cookies.remove('finish_price');

    if ((0, _jquery2.default)(_dom2.default.finishAddonTrigger).hasClass('is-active')) {
      addFinishAddon($product, finishId);
    } else {
      getState();
    }
  }).catch(function (error) {
    alert("couldn't add frame to cart: " + error);
  });
};

var addFinishAddon = function addFinishAddon(product, finish) {
  var addonId = parseInt((0, _jquery2.default)(_dom2.default.finishAddon).attr('data-variant-id'));
  var variantId = parseInt(product.find(_dom2.default.productVariant).val());
  var productHandle = product.find(_dom2.default.productForm).attr('data-product-handle');
  var productTitle = product.find(_dom2.default.productForm).attr('data-product-title');

  var properties = {
    "_custom_finish_addon_product": "true",
    "_custom_finish_poster_handle": productHandle,
    "_custom_finish_poster_id": variantId,
    "_custom_finish_frame_id": finish,
    "Custom finish addon for ": productTitle
  };

  cart.addItem(addonId, { quantity: 1, properties: properties }).then(function (item) {
    getState();
  }).catch(function (error) {
    alert("couldn't add frame to cart: " + error);
  });
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(document).on('submit', _dom2.default.productForm, function (e) {
    e.preventDefault();
    addLineItem((0, _jquery2.default)(this));
  });
};